<template>
  <div class="container-fluid w-100" style="overflow: hidden">
    <navbar v-if="!editMode" :title="$t('menu.contract_collections')" />
    <Transition name="fade">
      <contract-collection-list
        v-if="!editMode"
        :results="results"
        :contracts="contracts"
        @add="addNew"
        @edit="edit"
      />
    </Transition>

    <base-modal v-if="editMode" :allowOverflow="true" hide-header hide-footer size="lg">
        <contract-collection-editor
          ref="contractCollectionEditor"
          :contract-collection="contractCollection"
          :contract-collections="results"
          :contracts="contracts"
          @close="showList"
          @close-and-update="closeAndUpdate"
        />
    </base-modal>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import ContractCollectionList from "@/components/contract/collection/ContractCollectionList";
import ContractCollectionEditor from "@/components/contract/collection/ContractCollectionEditor";
import Navbar from "@/components/utils/Navbar.vue";
import BaseModal from "@/components/BaseModal";
import {timeUtils} from "../../mixins/TimeUtils.js";

export default {
    name: 'ContractCollections',
    components: {BaseModal, Navbar, ContractCollectionEditor, ContractCollectionList},
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            results: [],
            contractCollection: null,
            contracts: [],
            editMode: false,
            loading: false
        }
    },
    mounted: function () {
        this.fetchContracts()
        this.fetchContractCollections()
    },
    methods: {
        fetchContractCollections: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.contractCollectionUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        fetchContracts: function () {
            this.loading = true
            this.contracts = []
            this.restFetchParams(this.contractOpenUrl, {startDate: this.getStartOfTheDay(new Date())}, this.handleContracts)
        },
        handleContracts: function (response) {
            this.contracts = response.data
            this.loading = false
        },
        addNew: function () {
            this.contractCollection = {id: null, name: null, contracts: null, description: null}
            this.editMode = true
        },
        edit: function (contractCollection) {
            this.contractCollection = contractCollection
            this.editMode = true
        },
        showList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchContractCollections()
            this.showList()
        }

    }
}
</script>
